import setCookie from '@stencil/flights-utils/src/set-cookie';
import getCookie from '@stencil/flights-utils/src/get-cookie';
import { assignVariant } from '@ibibo/pokus-apis';
import { setExperimentDetails, setExperimentMetaData } from '../SRP/redux/actions';
import { EXPERIMENT_NAMES_FOR_PDT } from '@stencil/flights-constants';

export const getUniqueId = (key = 'gi_flt_identity') => {
  const val = getCookie(key);
  if (!val) {
    const cookieVal = new Date().getTime();
    setCookie(key, cookieVal, '', '/', window.location.host.replace('www.', ''), '');
    return cookieVal;
  }
  return val;
};

export const getPDTDetails = (fareIdentifier, fareOptionsInfo) => {
  if (fareIdentifier && fareOptionsInfo) {
    const fareOptions = Object.values(fareOptionsInfo);
    const fare = [].concat.apply([], fareOptions);
    const fareDetails = fare.find(o => o['identifier'] == fareIdentifier);
    return fareDetails;
  }
};

const parseExperimentDetails = (experimentDetailsList, experimentMetaDataValues = {}, expName) => {
  if (!experimentDetailsList || experimentDetailsList.length === 0) {
    return [];
  }
  if (expName === 'GI_FLT_FARE_FAMILY_PERSUASION') {
    let tempExperimentDetails = {};
    tempExperimentDetails['experiment_name'] = EXPERIMENT_NAMES_FOR_PDT[expName].name;
    tempExperimentDetails['experiment_value'] = experimentDetailsList[0][
      'exp_experiment_id'
    ].toString();
    tempExperimentDetails['experiment_variant_id'] = experimentMetaDataValues[
      EXPERIMENT_NAMES_FOR_PDT[expName].key
    ]
      ? experimentMetaDataValues[EXPERIMENT_NAMES_FOR_PDT[expName].key].toString()
      : 'false';
    experimentDetailsList[0] = tempExperimentDetails;
  }
  return experimentDetailsList;
};

export const getPokusExperimentDetails = expName => {
  return (dispatch, getState) => {
    const params = {
      attributes: {
        expName
      },
      lob: 'FLIGHT',
      user: {
        deviceId: getUniqueId()
      }
    };
    assignVariant(params)
      .then(response => {
        if (response) {
          dispatch(
            setExperimentDetails(
              // ssr: response?.perLobMap?.FLIGHT?.metadataValues?.mweb_srp_ssr || false,
              parseExperimentDetails(
                response?.perLobMap?.FLIGHT?.exp_experiment_details_list || [],
                response?.perLobMap?.FLIGHT?.metadataValues || {},
                expName
              )
            )
          );
          dispatch(
            setExperimentMetaData({ [expName]: response?.perLobMap?.FLIGHT?.metadataValues || {} })
          );
        }
      })
      .catch(err => {});
  };
};
